import { createMuiTheme } from '@material-ui/core/styles';
import { pink, grey } from '@material-ui/core/colors';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#3F51B5',
    },
    secondary: {
      main: pink["A400"],
    },
    muted: {
      main: grey[500],
    }
  },
  typography: {
    fontFamily: [
      "Roboto",
      "Noto Sans TC",
    ].join(','),
  },
  overrides: {
    MuiDialogTitle: {
      root: {
        backgroundColor: '#3F51B5',
        color: 'white',
      },
    },
    MuiInputAdornment: {
      root: {
        color: grey[500],
      }
    },
    MuiTextField: {
      root: {
        marginTop: '16px',
      }
    }
  },
  props: {
    MuiTextField: {
      variant: 'outlined',
      size: 'small',
      margin: 'none',
    },
  },
  customStyles: {
    inputAdornmentIconPointer: {
      cursor: "pointer"
    },
    logo: {
      width: '100%',
      padding: 0
    }
  }
});

export default theme; 